import { PoUploadEffects } from './po-upload.effect'

export const effects: any[] = [
  PoUploadEffects
]

export * from './po-upload.effect'
